import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from '@/router'
import i18n from './i18n'

import 'bootstrap-icons/font/bootstrap-icons.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'jquery'
import 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'popper.js'
import { Tabs, Tab } from 'vue3-tabs-component'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// ✅ Google Analytics
// import VueGtag from 'vue-gtag-next'

const pinia = createPinia()

const vuetify = createVuetify({
  components,
  directives
})

const app = createApp(App)

// app.use(VueGtag, {
//   property: {
//     id: 'G-5YEV4VF9VR'
//   }
// }, router)

app
  .use(router)
  .use(i18n)
  .use(pinia)
  .use(VueAxios, axios)
  .use(vuetify)
  .component('tabs', Tabs)
  .component('tab', Tab)
  .mount('#app')